/**
 * NotFoundPage — Standard 404 page for unmatched shell routes.
 * @layer layout
 * @package @plerity/dashboard-shell
 */

import { useNavigate } from "react-router-dom";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8">
      {/*
        axe color-contrast does NOT exempt aria-hidden text: the old
        text-gray-300 / dark:text-gray-700 glyph measured ~1.5:1 (live axe on
        ai, 2026-10-12). gray-500 / dark:gray-400 (the `text-muted` pair) is
        >= 4.6:1 on the gray-50 / gray-900 page surface in both themes.
      */}
      <span className="text-6xl font-bold text-gray-500 dark:text-gray-400" aria-hidden="true">
        404
      </span>
      {/*
        Heading contract (react-dashboard-a11y-requirements): a route owns the
        page's sole <h1>. DashboardLayout renders the app name as a styled <p>,
        so this 404 route must supply the h1 — the decorative "404" glyph above
        is aria-hidden and does not count. Was <h2> (no h1 on the page).
      */}
      <h1 className="text-xl font-semibold text-fg">Page not found</h1>
      <p className="max-w-md text-center text-sm text-gray-600 dark:text-gray-400">
        The page you're looking for doesn't exist or has been moved.
      </p>
      {/*
        Use `text-brand-fg` (NOT hardcoded text-white): the brand-fg token is
        white in light mode but flips to near-black in dark mode, where
        `bg-brand` resolves to a light sky-blue (--brand-primary-400). White
        text on that light-blue is only 2.47:1 (fails WCAG AA); brand-fg keeps
        the CTA >= AA in both themes. Focus ring uses the brand focus token.
      */}
      <button
        type="button"
        onClick={() => navigate("/")}
        className="mt-2 rounded-md bg-brand px-4 py-2 text-sm font-medium text-brand-fg hover:bg-brand-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-focus focus-visible:ring-offset-2"
      >
        Go to Dashboard
      </button>
    </div>
  );
}
